import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { contextOf, memberQueryOf } from '../_utils/queries';
export const usePartnersMember = isGuest => {
  const $ = _c(4);
  let t0;
  if ($[0] !== isGuest) {
    t0 = memberQueryOf(isGuest);
    $[0] = isGuest;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      ...t0,
      select: contextOf
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useSuspenseQuery(t1).data;
};